module.exports = __webpack_public_path__ + "img/portada_gourmet.c78e8f1a.jpg";